export const NS_GLOBAL = `NS_GLOBAL`;

/* LAYOUT */
export const CHANGE_LAYOUT = `${NS_GLOBAL}/CHANGE_LAYOUT`;
export const CHANGE_LAYOUT_WIDTH = `${NS_GLOBAL}/CHANGE_LAYOUT_WIDTH`;
export const CHANGE_SIDEBAR_THEME = `${NS_GLOBAL}/CHANGE_SIDEBAR_THEME`;
export const CHANGE_SIDEBAR_TYPE = `${NS_GLOBAL}/CHANGE_SIDEBAR_TYPE`;

// topbar
export const CHANGE_TOPBAR_THEME = `${NS_GLOBAL}/CHANGE_TOPBAR_THEME`;

// show sidebar
export const SHOW_SIDEBAR = `${NS_GLOBAL}/SHOW_SIDEBAR`;
export const TOGGLE_LEFT_MENU = `${NS_GLOBAL}/TOGGLE_LEFT_MENU`;

/* RIGHT SIDEBAR */
export const SHOW_RIGHT_SIDEBAR = `${NS_GLOBAL}/SHOW_RIGHT_SIDEBAR`;

// Loading
export const LOADING_REQUEST = `${NS_GLOBAL}/LOADING_REQUEST`;
export const LOADING_SUCCESS = `${NS_GLOBAL}/LOADING_SUCCESS`;

// Refresh token
export const REFRESH_TOKEN_REQUEST = `${NS_GLOBAL}/REFRESH_TOKEN_REQUEST`;

// Logo
export const SET_LARGE_LOGO_IMAGE = `${NS_GLOBAL}/SET_LARGE_LOGO_IMAGE`;

export const INIT_DATA = `${NS_GLOBAL}/INIT_DATA`;
